(function () {
  'use strict';

  var DISPLAY_SYMBOLS = {
    AUD: 'A$',
    EUR: '€',
    GBP: '£',
    JPY: 'JP¥',
    KRW: '₩',
    NZD: 'NZ$',
    CAD: 'C$',
    HKD: 'HK$',
    USD: '$'
  };

  function activeCurrency(options) {
    return String(
      (options && options.currency) ||
        (window.Shopify && Shopify.currency && Shopify.currency.active) ||
        ''
    ).toUpperCase();
  }

  function symbol(currency, fallback) {
    var code = String(currency || '').toUpperCase();
    return DISPLAY_SYMBOLS[code] || fallback || code;
  }

  function numberParts(value, currency, locale) {
    var formatter = new Intl.NumberFormat(locale || document.documentElement.lang || 'en', {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'code'
    });

    return formatter
      .formatToParts(value)
      .filter(function (part) {
        return ['integer', 'group', 'decimal', 'fraction'].indexOf(part.type) !== -1;
      })
      .map(function (part) {
        return part.value;
      })
      .join('');
  }

  function format(cents, options) {
    var numericCents = Number(cents);
    if (!Number.isFinite(numericCents)) return '';

    var currency = activeCurrency(options) || 'USD';
    var value = numericCents / 100;

    try {
      if (!DISPLAY_SYMBOLS[currency]) {
        return new Intl.NumberFormat((options && options.locale) || document.documentElement.lang || 'en', {
          style: 'currency',
          currency: currency
        }).format(value);
      }

      var prefix = symbol(currency);
      var number = numberParts(Math.abs(value), currency, options && options.locale);
      return (value < 0 ? '-' : '') + prefix + number;
    } catch (error) {
      var fallbackPrefix = symbol(currency, currency + ' ');
      return (value < 0 ? '-' : '') + fallbackPrefix + Math.abs(value).toFixed(2);
    }
  }

  window.LPMoney = {
    format: format,
    symbol: symbol
  };
})();
